var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiblioteka(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18125_12222",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18125_12222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3845 16.6155H8.3845V4H7.3845V16.6155ZM6.23075 21C5.61108 21 5.08442 20.7831 4.65075 20.3492C4.21692 19.9156 4 19.3889 4 18.7693V5.23075C4 4.61108 4.21692 4.08442 4.65075 3.65075C5.08442 3.21692 5.61108 3 6.23075 3H16.6155V17.6155H6.23075C5.89608 17.6155 5.60733 17.7294 5.3645 17.9572C5.1215 18.1851 5 18.4674 5 18.8042C5 19.1411 5.1215 19.4246 5.3645 19.6548C5.60733 19.8849 5.89608 20 6.23075 20H19V5H20V21H6.23075Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiblioteka);
export default __webpack_public_path__ + "static/media/biblioteka.00cce324c7c39f737735837d298c0f78.svg";
export { ForwardRef as ReactComponent };